import { createFileRoute } from "@tanstack/react-router";

import { GoldenReviewPage } from "@/features/golden-review/GoldenReviewPage";

export const Route = createFileRoute("/_authenticated/golden/review")({
  component: GoldenReviewPage,
});
